import { styled } from '@design-systems/utils';
import React from 'react';
import makeClass from 'clsx';
import { ThemeableElement } from '@design-systems/theme';
import styles from '../Badge.css';

export const BadgeLabel = styled('div', styles.label);

/** A slot for the value inside of the badge */
export const BadgeValue = (props: ThemeableElement<'div'>) => {
  const { className, children, ...html } = props;

  return (
    <div {...html} className={makeClass(styles.value, className)}>
      <div className={styles.iconFix}>{children}</div>
    </div>
  );
};

export default BadgeValue;
